import { Envelope } from './envelope';

export class EnvelopeStructure {
    public list: Array<Envelope>;
    public isList: boolean;

    /**
     *
     */
    constructor() {
        this.list = new Array<Envelope>();
        this.isList = false;
    }
}
